import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-stone-950 text-stone-300 py-10 border-t border-stone-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main 1-column content area */}
        <div className="flex flex-col items-center justify-center space-y-6 pb-8 border-b border-stone-800/80">
          {/* Logo */}
          <Link to="/" className="inline-block" aria-label="Gribskovsmeden ApS">
            <img
              src="https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/logo-10.png"
              alt="Gribskovsmeden ApS Logo"
              className="h-[18px] sm:h-[22px] lg:h-auto max-w-[140px] lg:!max-w-[320px] w-auto object-contain mx-auto"
            />
          </Link>

          {/* Description */}
          <p className="text-stone-400 text-xs sm:text-sm leading-relaxed max-w-md mx-auto">
            Professionel smed på Nordsjælland – vi specialiserer os i alt fra altaner og trapper til porte og stålkonstruktioner.
          </p>

          {/* Støttebanner */}
          <div className="pt-1 flex justify-center">
            <img
              src="https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/st-ttebanner-mid2026-500x250.jpg"
              alt="Gribskovsmeden Støttebanner"
              className="max-h-[150px] w-auto object-contain rounded border border-stone-800"
            />
          </div>

          {/* Vores ydelser */}
          <div className="pt-2 w-full">
            <h3 className="text-white font-bold mb-3 tracking-wider uppercase text-xs">
              Vores ydelser
            </h3>
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs sm:text-sm text-stone-400 max-w-2xl mx-auto">
              <Link
                to="/staalkonstruktioner"
                className="hover:text-amber-400 transition-colors"
              >
                Stålkonstruktioner
              </Link>
              <span className="text-stone-700 select-none">•</span>
              <Link
                to="/raekvaerk"
                className="hover:text-amber-400 transition-colors"
              >
                Rækværk
              </Link>
              <span className="text-stone-700 select-none">•</span>
              <Link
                to="/trapper"
                className="hover:text-amber-400 transition-colors"
              >
                Trapper
              </Link>
              <span className="text-stone-700 select-none">•</span>
              <Link
                to="/porte"
                className="hover:text-amber-400 transition-colors"
              >
                Porte
              </Link>
              <span className="text-stone-700 select-none">•</span>
              <Link
                to="/hegn"
                className="hover:text-amber-400 transition-colors"
              >
                Hegn
              </Link>
              <span className="text-stone-700 select-none">•</span>
              <Link
                to="/altan"
                className="hover:text-amber-400 transition-colors"
              >
                Altan
              </Link>
              <span className="text-stone-700 select-none">•</span>
              <Link
                to="/vi-tilbyder"
                className="hover:text-amber-400 transition-colors"
              >
                Vi tilbyder (Smedearbejde)
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-stone-500">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 mx-auto sm:mx-0">
            <p>© {new Date().getFullYear()} Gribskovsmeden ApS. CVR: 32660681. Alle rettigheder forbeholdes.</p>
            <span className="hidden sm:inline text-stone-700 select-none">•</span>
            <div className="flex items-center gap-3">
              <a
                href="https://www.iubenda.com/privacy-policy/31277681"
                className="iubenda-white iubenda-noiframe iubenda-embed text-stone-400 hover:text-white transition-colors"
                title="Privatlivspolitik "
              >
                Privatlivspolitik
              </a>
              <span className="text-stone-700 select-none">•</span>
              <a
                href="https://www.iubenda.com/privacy-policy/31277681/cookie-policy"
                className="iubenda-white iubenda-noiframe iubenda-embed text-stone-400 hover:text-white transition-colors"
                title="Cookiepolitik "
              >
                Cookiepolitik
              </a>
            </div>
          </div>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-stone-400 hover:text-amber-400 transition-colors cursor-pointer mx-auto sm:mx-0"
          >
            <span>Gå til toppen</span>
            <i className="fa-solid fa-arrow-up" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </footer>
  );
}
